/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from "react"
import { get, useFormState } from "react-hook-form"

import classNames from "classnames"

import { useEvent } from "shared/lib/useEvent"

import { InputContext } from "./Input"
import { InputControlWrapper } from "./InputControlWrapper"

const InputFocusBase = React.memo(
  ({
    className,
    onClick,
    children,
    ...rest
  }: React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>>) => {
    const { disabled, inputRef } = useContext(InputContext)

    const focusInput = useEvent(() => inputRef?.current?.focus())

    const handleClick: React.MouseEventHandler<HTMLDivElement> = useEvent(
      ev => {
        focusInput()
        onClick?.(ev)
      }
    )
    return (
      <InputControlWrapper>
        <div
          {...rest}
          onClick={handleClick}
          className={classNames(
            "input__focus",
            "input__control",
            { disabled },
            className
          )}
        >
          {children}
        </div>
      </InputControlWrapper>
    )
  }
)

const HookFormInputFocus = React.memo(
  ({
    className,
    ...props
  }: React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>>) => {
    const { name } = useContext(InputContext)

    const { errors } = useFormState({ name })
    const error = !!get(errors, name)

    return (
      <InputFocusBase {...props} className={classNames({ error }, className)} />
    )
  }
)

export const InputFocus = React.memo(
  (props: React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>>) => {
    const { name } = useContext(InputContext)
    if (name) {
      return <HookFormInputFocus {...props} />
    }
    return <InputFocusBase {...props} />
  }
)
